<template>
  <div class="consumer-content">
    <div class="consumer-content__heading">
      <Title class="consumer-content__heading__title">
        Código de defesa do consumidor
      </Title>
      <p class="consumer-content__heading__subheading">
        Saiba dos seus direitos através do código do consumidor online.
      </p>
    </div>

    <div class="consumer-content__container">
      <ConsumerText />
    </div>
  </div>
</template>

<script>
import Title from '@/components/common/Title.vue';
import ConsumerText from '@/components/consumerDefenseComponents/ConsumerText.vue';

export default {
  name: 'ConsumerContent',

  components: {
    Title,
    ConsumerText
  }
};
</script>

<style lang="scss" scoped>
.consumer-content {
  margin: 0;

  @include screen(tablet-up) {
    margin: 40px 0;
  }

  &__heading {
    display: flex;
    flex-direction: column;
    gap: 7px;

    &__title,
    &__subheading {
      display: none;

      @include screen(tablet-up) {
        display: block;
      }
    }
  }
}
</style>
